import { render, staticRenderFns } from "./SimpleTextComponent.vue?vue&type=template&id=bfb8c05c&scoped=true"
import script from "./SimpleTextComponent.vue?vue&type=script&lang=ts"
export * from "./SimpleTextComponent.vue?vue&type=script&lang=ts"
import style0 from "./SimpleTextComponent.vue?vue&type=style&index=0&id=bfb8c05c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb8c05c",
  null
  
)

export default component.exports